import { faFacebook, faInstagram, faLinkedin, faYoutube } from "@fortawesome/free-brands-svg-icons";

export const footerLinks = [
  {
    id: 1,
    icon: faLinkedin,
    url: "https://www.linkedin.com/company/careerninja/mycompany/",
  },
  {
    id: 2,
    icon: faInstagram,
    url: "https://www.instagram.com/learntube.ai/?hl=en",
  },
  {
    id: 3,
    icon: faYoutube,
    url: "https://www.youtube.com/channel/UCxX6KabxbGpk9Be57xMktRQ",
  },
  {
    id: 4,
    icon: faFacebook,
    url: "https://www.facebook.com/CareerNinjaIndia/",
  }
  
  
];